import IconButton from "@weave-design/icon-button";
import { Visible24, Hidden24 } from "@weave-design/icons";
import eventBus from "../../../eventBus/eventDispatcher";

type Props = {
    id: string;
    isVisible: boolean;
};

export const LinkedModelVisibilityControl = ({ id, isVisible }: Props) => {
    const toggleVisibility = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        eventBus.dispatchEvent({
            type: "Dextall.LinkedModels.UI.ChangeVisibility",
            payload: { id, visible: !isVisible },
        });
    };

    return (
        <IconButton
            icon={<div style={{ width: 24, height: 24 }}>{isVisible ? <Hidden24 /> : <Visible24 />}</div>}
            title={isVisible ? "Hide linked model" : "Show linked model"}
            onClick={toggleVisibility}
        />
    );
};
